import { Row, theme } from '@policygenius/mortar';
import styled, { css } from 'styled-components';
import { fontWeight, suisseIntl, victorSerif } from '../typography';

export const Container = styled(Row)`
  text-align: center;
  min-height: 200px;
  display: grid;
  align-items: center;
  padding: 8px 16px 80px;
`;

export const FeedbackTitle = styled.h2`
  ${victorSerif()};
  margin: 0 0 24px;
  color: #131212;
  font-size: 34px;
  line-height: 1.1;
  letter-spacing: 0;

  @media (min-width: ${theme.breakpoints.medium}px) {
    font-size: 64px;
    line-height: 1.1;
    margin-bottom: 20px;
  }
`;

export const FeedbackTitleHighlight = styled.span`
  position: relative;
  display: inline;
  white-space: nowrap;
`;

export const FeedbackTitleUnderlineWrap = styled.span`
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  line-height: 0;
  pointer-events: none;
`;

const feedbackTitleUnderlineDraw = css`
  @keyframes feedbackTitleUnderlineDraw {
    from {
      stroke-dashoffset: 1;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
`;

export const FeedbackTitleUnderlineSvg = styled.svg`
  display: block;
  width: 100%;
  height: auto;

  path {
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
    animation: feedbackTitleUnderlineDraw 0.9s cubic-bezier(0.4, 0, 0.2, 1) 0.35s forwards;
  }

  ${feedbackTitleUnderlineDraw}

  @media (prefers-reduced-motion: reduce) {
    path {
      stroke-dashoffset: 0;
      animation: none;
    }
  }
`;

export const FeedbackBody = styled.p`
  ${suisseIntl(fontWeight.regular)};
  margin: 0;
  color: #131212;
  font-size: 18px;
  line-height: 1.3;

  @media (min-width: ${theme.breakpoints.medium}px) {
    font-size: 24px;
  }

  a {
    ${suisseIntl(fontWeight.regular)};
    font-size: 18px;
    color: #d44414;

    @media (min-width: ${theme.breakpoints.medium}px) {
      font-size: 24px;
    }
  }
`;
